import React, { useState } from 'react';
import { DoRender } from '../Utils/shared';
import { LinearProgress, Table, TableRow, TableBody, Paper } from 'material-ui';
import currencyFormatter from 'currency-formatter';
import { TableHead } from 'material-ui';
import { TableCell } from 'material-ui';
import { Typography } from 'material-ui';
import { Grid } from 'material-ui';
import { PaymentIframe } from '../Reservation/ReservationConfirmView';
import OLYWebPageComponent from '../OLYWebPageComponent';
import translate from 'react-i18next/dist/commonjs/translate';
import { withStyles } from 'material-ui/styles';
import { Button } from 'material-ui';
import DynIcon from '../Utils/DynIcon';
import { getPaymentToken } from '../Reservations/reservationsServices';
import InformationPanel from '../../ui/InformationPanel';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        flexGrow: 1
    },
    table: {
        minWidth: 800,
    },
    price: {
        marginTop: '0px',
        marginBottom: '4px',
        fontWeight: 700,
        fontSize: '1.5em',
        color: 'var(--error-color)',
        textAlign: 'right'
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    bookingLocator: {
        color: 'var(--primary-color)'
    },
    bookingTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem',
        borderLeft: '2px solid ' + theme.palette.primary.main
    },
});

class PendingPaymentsReservations extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        this.state = {
            pendingPayments: props.location.state && props.location.state.pendingPayments ? props.location.state.pendingPayments : [],
            loading: false,
            iframeToken: null,
            operationstatus: 'info',
            hideIcon: false,
            mode: 'indeterminate',
            operationtext: '',
            operationtitle: '',
            processing: false
        };
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        let { pendingPayments, iframeToken, merchantOperation } = this.props.location.state ? this.props.location.state : [];
        if (pendingPayments && pendingPayments.length) {
            localStorage.setItem('pendingPayments', JSON.stringify(pendingPayments));
            await this.setState({ iframeToken, merchantOperation });
        } else {
            await this.setState({ pendingPayments: JSON.parse(localStorage.getItem('pendingPayments')), iframeToken, merchantOperation });
        }
    }

    componentWillUnMount() {
        localStorage.removeItem('pendingPayments');
    }

    onCancelAndBack() {
        localStorage.removeItem('pendingPayments');
        const location = {
            pathname: '/bookings',
        };
        this.props.history.push(location);
    }

    render() {
        const { t, classes } = this.props;
        const B2bVerPVP = this.currentUser.authorities.includes('B2bVerPVP');
        const totalPendingPrice = this.state.pendingPayments && this.state.pendingPayments.length ? this.state.pendingPayments.reduce((acc, val) => (acc + val.pendingPayment.price), 0) : 0;
        return (
            <div className="cmsPendingPayments">
                <div className="cmsContainer">
                    {this.state.processing &&
                        <InformationPanel
                            hideIcon={this.state.hideIcon}
                            type={this.state.operationstatus}
                            title={this.state.operationtitle}
                            onCancel={e => { this.setState({ hideIcon: false, processing: false }); }}
                            text={this.state.operationtext}>
                        </InformationPanel>
                    }
                    {/* <LinearProgress className="cmsProgressBar" value={this.state.completed} variant={this.state.mode} /> */}
                    {/* </InformationPanel> */}
                    <div className="payments-container">
                        <div className="pending-payments">
                            <Typography>{t('COMMON.RESERVATIONS')}</Typography>
                            <Table aria-label="simple table" className="payments-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="payments-table-header">{t('BOOKINGS.LOCATOR')}</TableCell>
                                        <TableCell className="payments-table-header">{t('BOOKINGS.PRICE')}</TableCell>
                                        <TableCell className="payments-table-header">{t('COMMON.PENDING_AMOUNT_TO_PAY')}</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {this.state.pendingPayments && this.state.pendingPayments.map((row) => {
                                        const totalPrice = row && row.hotel && row.hotel.cancellationInsuranceAcepted &&
                                            row.hotel.cancellationInsurance ? row.price + Number(row.hotel.cancellationInsurance.price) : row.price;
                                        const totalPvPPrice = row && row.hotel && row.hotel.cancellationInsuranceAcepted &&
                                            row.hotel.cancellationInsurance ? row.pvp + Number(row.hotel.cancellationInsurance.pvp) : row.pvp;
                                        return (
                                            <TableRow key={row.locator}>
                                                <TableCell align="right">
                                                    <a href={'#/bookings/' + row.olympiaLocator + '/view'}
                                                        className={classes.bookingLocator} target='_blank' rel='noopener noreferrer'>
                                                        <b>{row.olympiaLocator}</b>
                                                    </a>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <strong>
                                                        {!B2bVerPVP ?
                                                            currencyFormatter.format(parseFloat(totalPrice), { code: 'EUR' })
                                                            : currencyFormatter.format(parseFloat(totalPvPPrice), { code: 'EUR' })
                                                        }
                                                    </strong>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <strong>
                                                        {currencyFormatter.format(parseFloat(row.pendingPayment.price), { code: 'EUR' })}
                                                    </strong>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                            <Grid container item xs={12} style={{ marginTop: '2rem' }}>
                                <Grid item xs={8} style={{ textAlign: 'right' }}>
                                    <Typography variant={'title'}>
                                        <div>
                                            {t('PENDING_PAYMENTS.AMOUNT_TO_PAY')}
                                        </div>
                                    </Typography>
                                </Grid>
                                <Grid item xs={4} style={{ textAlign: 'left' }}>
                                    <Typography variant={'title'}>
                                        <div className={this.props.classes.price} >
                                            {currencyFormatter.format(parseFloat(totalPendingPrice), { code: 'EUR' })}
                                        </div>
                                    </Typography>
                                </Grid>
                            </Grid>
                            <div className="payments-button-container">
                                <Button
                                    onClick={() => this.onCancelAndBack()}>
                                    <DynIcon icon="KeyboardArrowLeft" />
                                    {t('CONFIRM_BOOKING.CANCEL_AND_BACK')}
                                </Button>
                            </div>
                        </div>
                        <div className="iframe-payments">
                            <DoRender if={!this.state.loading && this.state.iframeToken}>
                                <Grid container style={{ height: '90%' }}>
                                    <div class="CmsPaymentIframe"><p>{t('CONFIRM_MODIFY_BOOKING.PAYMENT_DATA')}</p></div>
                                    <PaymentIframe token={this.state.iframeToken} style={{ height: '90%' }} t={t} />
                                </Grid>
                            </DoRender>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(PendingPaymentsReservations));


// WEBPACK FOOTER //
// ./src/components/Payments/PaymentPendingReservations.js